import Class from './v-tab';
import './v-tab@';

export default Class;